import { useState } from "react";
import axios from "axios";
import { useDecimalInput } from "../../../hooks/useDecimalInput";
import { PRECISION } from "../../../precision";

const AddCredit = ({ id, onClose, setAlertConfig, onSuccess }) => {
    const { input: amount, bind: bindAmount, reset: resetAmount } = useDecimalInput();
    const [note, setNote] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const token = localStorage.getItem("token");

    const submit = async () => {
        const n = Number(amount);
        if (!Number.isFinite(n) || n <= 0) {
            setAlertConfig({ show: true, message: "Enter a valid amount", type: "danger" });
            return;
        }
        setSubmitting(true);
        try {
            const res = await axios.post(
                `${process.env.REACT_APP_API_ENDPOINT}merchant/${id}/grant-credit`,
                { amount: Number(n.toFixed(PRECISION)), note: note?.trim() || null },
                { headers: { Authorization: `Bearer ${token}` } },
            );
            setAlertConfig({ show: true, message: res.data.message, type: res.data.code === 1 ? "success" : "danger" });
            if (res.data.code === 1) {
                onSuccess();
                onClose();
            }
        } catch (err) {
            setAlertConfig({ show: true, message: "Something went wrong", type: "danger" });
            console.error(err);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="modal fade show d-block">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Add Credit</h5>
                        <button className="btn-close" onClick={onClose} />
                    </div>
                    <div className="modal-body p-4">
                        <div className="mb-3">
                            <label className="form-label">Amount (KWD)</label>
                            <input type="number" step="0.001" className="form-control" {...bindAmount} placeholder="e.g. 500" />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Note (optional)</label>
                            <textarea className="form-control" value={note} onChange={(e) => setNote(e.target.value)} />
                        </div>
                        <p className="text-muted mb-0">
                            This credits the merchant's wallet immediately. It's tracked separately and counted
                            against topups received this calendar month when the cycle closes.
                        </p>
                    </div>
                    <div className="modal-footer">
                        <button className="btn btn-secondary btn-sm" onClick={onClose}>Close</button>
                        <button className="btn btn-primary btn-sm" onClick={submit} disabled={submitting}>
                            {submitting ? "Adding..." : "Add Credit"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddCredit;